import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AliyunOutlinedSvg from "@ant-design/icons-svg/es/asn/AliyunOutlined";
import AntdIcon from "../components/AntdIcon";
var AliyunOutlined = function AliyunOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AliyunOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  AliyunOutlined.displayName = 'AliyunOutlined';
}
export default /*#__PURE__*/React.forwardRef(AliyunOutlined);